import { DependencyList, EffectCallback, useEffect } from 'react'
import useSWR from 'swr'
import { FAST_INTERVAL, SLOW_INTERVAL } from 'config/constants/intervals'
import { useWagmi } from 'libs/wagmi'

type BlockEffectCallback = (blockNumber: number) => ReturnType<EffectCallback>

export function useFastRefreshEffect(effect: BlockEffectCallback, deps?: DependencyList) {
  const { chainId } = useWagmi()
  const { data = 0 } = useSWR(chainId && [FAST_INTERVAL, 'blockNumber', chainId])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect.bind(null, data), [data, ...(deps ?? [])])
}

export function useSlowRefreshEffect(effect: BlockEffectCallback, deps?: DependencyList) {
  const { chainId } = useWagmi()
  const { data = 0 } = useSWR(chainId && [SLOW_INTERVAL, 'blockNumber', chainId])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect.bind(null, data), [data, ...(deps ?? [])])
}
